import React from 'react'
import propTypes from 'prop-types'
import ProductCard from 'store/components/ProductCard'
import localPropTypes from 'store/pages/category/components/Catalog/prop-types'

const Layout = ({ products }) => {
  return (
    <div className="prod_lists_big">
      {products.map(
        (product) => (
          <ProductCard
            key={product.id}
            showComparison={false}
            showFavorites={false}
            showFavoritesDelete
            {...product}
          />
        ),
      )}
      <div className="clear" />
    </div>
  )
}

Layout.propTypes = {
  products: propTypes.arrayOf(localPropTypes.Product),
}

export default Layout
